import { selector } from 'recoil';
import { OnlineSalesUnauthenticated } from 'gw-edge-client';
import { jobInfoAtom } from '../atoms/jobInfoAtom';
import { allCoverablesOnsaAtom } from '../atoms/allCoverablesOnsaAtom';
import { getOnsaCurrentProductSelector } from './getOnsaCurrentProductSelector';
import { getCoverableIndex } from '../../utils/coverablesUtil';
import type { OnsaMvpVmrPopulatorDTO } from 'gw-edge-client/dist/types/dto/pc/top/edge/capabilities/onlinesales/dto/onsa/motor';
import { isLoggedOnSelector } from './isLoggedOnSelector';

export const carMakeSelector = selector<OnsaMvpVmrPopulatorDTO>({
    key: 'carMakeSelector',
    get: async ({ get }) => {
        const { jobNumber, sessionId } = get(jobInfoAtom);
        const coverables = get(allCoverablesOnsaAtom);
        const currentProduct = get(getOnsaCurrentProductSelector);
        const { cars = [] } = coverables;
        const coverableIndex = getCoverableIndex(cars, currentProduct.fixedId);
        const coverable = cars[coverableIndex];
        const isLoggedOn = get(isLoggedOnSelector);

        if (!jobNumber || !sessionId) {
            throw new Error('Invalid quote or session ID');
        }
        return await OnlineSalesUnauthenticated.getVMRData(
            jobNumber,
            sessionId,
            {
                vehicleID: coverable.fixedId,
                lookUpFieldName: 'Make'
            },
            !isLoggedOn
        );
    }
});
